import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const steps = [
  {
    number: "1",
    title: "Install The App",
    text: "Download Vasta from the App Store or Google Play.",
  },
  {
    number: "2",
    title: "Choose Your Service",
    text: "Browse categories like beauty, home care, fitness, medical, pets, and more.",
  },
  {
    number: "3",
    title: "Book & Relax",
    text: "Confirm instantly, pay securely, and let our verified experts handle the rest.",
  },
];

const HowItWorks = () => {
  return (
    <section id="howitwork" className="py-5" style={{backgroundColor:"#F3F7FA"}}>
      <Container>
        <h2 className="text-center mb-5 fs_48 fw-semibold">How It Works</h2>

        <div className="position-relative">
          {/* Dotted line only between first and last circle */}
          <div
            className="d-none d-md-block position-absolute"
            style={{
              top: "25px",
              left: "calc(16.66% + 20px)", // center of 1st column
              right: "calc(16.66% + 20px)", // center of 3rd column
              borderTop: "2px dashed #ccc",
              zIndex: 0,
            }}
          ></div>

          <Row className="text-center">
            {steps.map((step, index) => (
              <Col md={4} key={index} className="mb-4">
                <div className="d-flex flex-column align-items-center position-relative">
                  <div
                    className="rounded-circle text-white d-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      fontSize: "20px",
                      fontWeight: "bold",
                      zIndex: 1,backgroundColor:"#044434"
                    }}
                  >
                    {step.number}
                  </div>
                  <h5 className="fw-semibold fs_20 ">{step.title}</h5>
                  <p style={{maxWidth:"280px"}} className="text-muted small">{step.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;
